<ng-container *ngIf="step === 1">
  <div class="modal-header mx-3">
    <div class="d-flex w-100 justify-content-center">
      <span class="fs-4 fw-bolder poppins">Conecte suas contas com segurança</span>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()"></button>
  </div>
  <div class="modal-body mx-5 poppins">
    <p class="text-center mb-4 fw-semibold">Simplifique sua vida financeira com o Open Finance e tenha todas as suas
      contas em um único lugar.</p>
    <p class="fw-semibold">‌Escolha a instituição financeira</p>
    <input id="input-search" type="text" placeholder="Buscar instituição  com a qual você tem relacionamento"
      [(ngModel)]="search" class="form-control form-control-lg" />
    <div class="overflow-y-auto">
      <div class="row g-3 my-4 mx-0" [style.height.px]="bodyHeight">
        <div class="col-12 col-md-6 col-lg-4 col-xxl-3"
          *ngFor="let item of organizations | filter: search : 'authorization_friendly_name'">
          <div class="card border-secondary border-1" (click)="organization = item" role="button"
            [ngClass]="{'bg-primary-subtle border-primary': organization.id === item.id}">
            <div class="row g-0">
              <div class="col-4 text-center p-1">
                <img [src]="item.authorization_logo" width="60" height="60" />
              </div>
              <div class="col-8 d-flex align-items-center">
                <span class="capitalize-first-letter fs-7">{{item.authorization_friendly_name}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex gap-5 justify-content-center mt-4">
      <button type="button" class="btn btn-outline-dark col col-md-5 col-lg-3" data-dismiss="modal"
        (click)="close('back')">
        VOLTAR
      </button>
      <button type="button" class="btn btn-primary col col-md-5 col-lg-3" (click)="selectOrganization(organization)"
        [disabled]="!organization?.authorization_uuid">
        CONTINUAR
      </button>
    </div>
    <div class="row">
      <div class="col-12 text-center fw-semibold my-3">
        <em class="bi bi-lock-fill me-3 fs-5"></em>
        <span class="fs-7">Para maiores informações, acesse o
          <a href="https://openfinancebrasil.org.br/" target="_blank">Portal do Open Finance Brasil.</a>
        </span>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="step === 2">
  <div class="modal-header mx-3">
    <div class="d-flex w-100 justify-content-center">
      <span class="fs-5 fw-bolder">Confirme os dados para concluir o compartilhamento</span>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()"></button>
  </div>
  <div class="modal-body mx-5">
    <p class="text-center mb-4 fw-semibold">Você está iniciando o processo de autorização para o compartilhamento
      dos seus dados com segurança, seguindo
      as diretrizes do Open Finance.</p>
    <div class="row gap-2 mt-3 justify-content-center align-items-center">
      <div class="col-3 text-center">
        <p class="mb-0 fs-7">&nbsp;</p>
        <div class="card border-1 border-secondary p-3" [style.height.px]="140">
          <div class="d-flex justify-content-center align-items-center h-100">
            <img src="assets/images/png/open-finance/lb-logo.png" class="img-fluid" />
          </div>
        </div>
        <p class="mb-0 fs-7">LadyBank</p>
        <p class="mb-0 fs-7">&nbsp;</p>
      </div>
      <div class="col-auto">
        <img src="assets/images/png/open-finance/Signpost2.png" width="70" class="img-fluid" />
      </div>
      <div class="col-3 text-center">
        <p class="mb-0 fs-7">Instituição selecionada:</p>
        <div class="card border-0" [style.height.px]="140">
          <div class="d-flex justify-content-center align-items-center h-100">
            <img [src]="organization.authorization_logo" class="img-fluid h-100" />
          </div>
        </div>
        <p class="mb-0 fs-7">{{organization.authorization_friendly_name}}</p>
        <p class="mb-0 fs-7 text-link" (click)="onChangeOrganization()">Alterar</p>
      </div>
    </div>
    <div class="row justify-content-center border-top border-bottom py-3">
      <div class="col-5">
        <p class="fw-bold">Para que seus dados serão utilizados</p>
        <ul class="list-group list-group-flush">
          <li>Recomendações para produtos e serviços financeiros</li>
          <li>Controle de todas suas finanças em um só lugar</li>
          <li>Personalização de produtos para o seu perfil</li>
        </ul>
      </div>
      <div class="col-auto border-start"></div>
      <div class="col-5">
        <p class="fw-bold">Quais dados serão compartilhados</p>
        <ul class="list-group list-group-flush">
          <li>Informações cadastrais </li>
          <li>Contas</li>
          <li>Crédito (contratos e operações)</li>
          <li>Investimentos</li>
          <li>Câmbio</li>
        </ul>
      </div>
    </div>
    <div class="d-flex gap-5 justify-content-center mt-4">
      <button type="button" class="btn btn-outline-dark col col-md-5 col-lg-3" data-dismiss="modal"
        (click)="onChangeOrganization()">
        VOLTAR
      </button>
      <a [href]="" (click)="onRedirect()" class="btn btn-primary col col-md-5 col-lg-3" target="_blank">
        REDIRECIONAR
      </a>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-11 col-lg-10 mx-auto my-3">
        <div class="d-flex justify-content-center align-items-center">
          <div class="col-auto">
            <em class="bi bi-exclamation-square fs-3"></em>
          </div>
          <div class="col ms-3">
            <p class="mb-0 fw-semibold fs-7">‌O link de acesso é único e válido apenas para uma tentativa.</p>
            <p class="mb-0 fs-7">Se você sair da tela ou não concluir a autorização, será necessário reiniciar o
              processo.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>